import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import ManagedGridView from "../controls/ManagedGridView";
import {
  receiptsViewColumns,
  mapReceiptsViewQuery,
  receiptsSearchSchema,
} from "./ReceiptsView.default";
import { getNotificationRecipients } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";

export interface ReceiptsViewProps {
  readonly trigger?: string;
  /** Lock the grid to a single notification's receipts (the drill from the All grid). */
  readonly notificationUid?: string;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function ReceiptsView(props: ReceiptsViewProps) {
  // When locked to a notification, fold that filter into every query so the grid, onSearch and Export agree.
  const mapQuery = (values: any): SearchQuery => {
    const query = mapReceiptsViewQuery(values);
    if (!props.notificationUid) return query;
    return {
      conditions: [
        ...query.conditions,
        {
          field: "notificationUid",
          operation: QueryOperation.Equal,
          values: [props.notificationUid],
        },
      ],
    };
  };

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={receiptsViewColumns}
      schema={receiptsSearchSchema}
      mapQuery={mapQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getNotificationRecipients, { retry: true })}
      pageSize={100}
      initialValues={props.notificationUid ? {} : undefined}
      autoSearch={!!props.notificationUid}
    />
  );
}

export default ReceiptsView;
